import { parsePhoneNumberFromString } from 'libphonenumber-js'

type GetTelLinkParams = {
  guid?: string
  phone: string
}
export const getTelLink = ({ guid, phone }: GetTelLinkParams) => {
  const protocol = 'tel://'
  const useGuid = guid ? `?recordId=${guid}&recordModule=account` : ''
  const clearNumber = `+${phone.replace(/\D/g, '')}`
  const phoneNumber = parsePhoneNumberFromString(clearNumber)?.number || clearNumber
  return `${protocol}${phoneNumber}${useGuid}`
}
